// extracted by mini-css-extract-plugin
export default {"clearFilter":"ProjectFilter_clearFilter_T8hnR","customSelectAdministratorStatus":"ProjectFilter_customSelectAdministratorStatus_CTnEz","spinAround":"ProjectFilter_spinAround_COAwv"};